import * as React from 'react';
import {NavLink} from 'react-router';

import {StudentTab} from './studentTabs';
import {StudentTheme} from './studentTheme';

interface Props {
  tabs: StudentTab[];
  theme: StudentTheme;
}

export const StudentTabBar: React.FC<Props> = ({tabs, theme}) => (
  <nav
    className="student-tabbar"
    aria-label="Navegação principal"
    style={{backgroundColor: theme.background, borderTopColor: theme.border}}
  >
    {tabs.map((tab) => (
      <NavLink
        key={tab.screen}
        to={`/${tab.screen}`}
        className="student-tabbar__item"
        style={({isActive}) => ({color: isActive ? theme.primary : theme.text})}
      >
        <i className={`fa-light ${tab.icon} student-tabbar__icon`} aria-hidden="true" />
        <span className="student-tabbar__label">{tab.label}</span>
      </NavLink>
    ))}
  </nav>
);
